import { useTranslation } from 'react-i18next';
import { ReqType } from 'utils/REQ';
import RequestButton, {
  RequestButtonProps
} from '_common/components/button/RequestButton';

type SignupRequestButtonProps = {
  req: ReqType;
  onSubmit: RequestButtonProps['onSubmit'];
  buttonLabel?: string;
  successMessage?: string;
  pendingMessage?: string;
  errorMessage?: string;
  validationErrorMessage?: string;
};

const SignupRequestButton = ({
  req,
  onSubmit,
  buttonLabel,
  successMessage,
  pendingMessage,
  errorMessage,
  validationErrorMessage
}: SignupRequestButtonProps) => {
  const { t } = useTranslation();
  return (
    <RequestButton
      req={req}
      onSubmit={onSubmit}
      buttonLabel={buttonLabel || t('signup:userRegister')}
      successMessage={successMessage || t('signup:signupSuccessMessage')}
      pendingMessage={pendingMessage || t('signup:userPendingMessage')}
      errorMessage={errorMessage || t('signup:userErrorMessage')}
      validationErrorMessage={validationErrorMessage}
    />
  );
};

export default SignupRequestButton;
